var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCoin24X24 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD200",
  fillRule: "evenodd",
  d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE749",
  fillRule: "evenodd",
  d: "M12 17.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEBE43",
  fillRule: "evenodd",
  d: "M12.187 14.24a.4.4 0 0 0-.373 0l-1.615.85a.4.4 0 0 1-.58-.422l.308-1.799a.4.4 0 0 0-.115-.354l-1.307-1.274a.4.4 0 0 1 .221-.682l1.807-.262a.4.4 0 0 0 .3-.22l.809-1.636a.4.4 0 0 1 .717 0l.808 1.637a.4.4 0 0 0 .301.219l1.806.262a.4.4 0 0 1 .222.682l-1.307 1.274a.4.4 0 0 0-.115.354l.308 1.8a.4.4 0 0 1-.58.421z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCoin24X24);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };